interface IconWordProps {
    word: string;
}

const IconWord = ({ word }: IconWordProps) => (
    <span className="text-zinc-950 dark:text-zinc-50 text-xs font-bold">{word}</span>
);
export default IconWord;
